/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import React from 'react';

import { InfoItem } from '@molecules';
import { usePage, useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const Item = ({ module, errors, ...props }) => {
  const { pageId, url } = module.content;
  const { page, isFetching, error } = usePage({ id: pageId });
  const { media } = useMedia(getImage(module.content));
  const description = (isFetching && 'Loading ...') || error?.message || url || page.title;

  return (
    <InfoItem.WithError error={errors} size="large" image={media.src} description={description} {...props}>
      Promotional Banner
    </InfoItem.WithError>
  );
};

export default Item;
